import styled from 'styled-components';
import colors from 'styles/colors';

import calendarIcon from 'assets/calendar.svg';
import clockIcon from 'assets/clock.svg';

export const TimeLogContainer = styled.div`
  display: flex;
  align-items: center;
  width: calc(100% - 80px);
  margin: auto;
  padding: 20px 0;
  border-bottom: 1px solid ${colors.gray80};

  > div {
    display: flex;
    align-items: center;
    font-weight: 600;
    font-size: 12px;
    line-height: 17px;

    &:first-child {
      margin-right: 45px;
    }
  }
`;

export const Picker = styled.input`
  border: 0;
  margin-left: 10px;
`;

export const Icons = styled.span`
  background-position-x: left;
  background-repeat: no-repeat;
  width: 20px;
  height: 20px;
`;

export const CalendarIcon = styled(Icons)`
  background-image: url(${calendarIcon});
`;

export const ClockIcon = styled(Icons)`
  background-image: url(${clockIcon});
`;

// For contextual overrides
export const DatePickerWrapper = styled.div``;

// For contextual overrides
export const TimePickerWrapper = styled.div``;
